module.exports = __webpack_public_path__ + "img/user-8.9362f17c.svg";